import React from 'react';
import classnames from 'classnames';
import { Bubble, BubbleProps } from 'tea-component';
import SvgIcon from '@home/components/SvgIcon';
import ChangeLogs, { IChangeLog } from '@gp/components/ChangeLogs';

import './index.scss';

interface ITimeChangeProps extends BubbleProps {
  data?: IChangeLog[];
}

const TimeChange: React.FC<ITimeChangeProps> = (props) => {
  const { className, data, ...restProps } = props;

  if (!Array.isArray(data) || !data.length) return null;

  return (
    <Bubble
      {...restProps}
      className={classnames('dbg-bubble-max-width dbg-time-change-bubble', className)}
      dark
      placement="right"
      positionFixed={false}
      content={<ChangeLogs className="dbg-time-change-logs" data={data} />}
    >
      <div className="dbg-time-change-icon-wrapper">
        <SvgIcon className="dbg-time-change-icon" type="updating" />
      </div>
    </Bubble>
  );
};

export default TimeChange;
